import React, { useEffect, useState } from "react";
import {
  CreditCardIcon,
  CurrencyRupeeIcon,
} from "@heroicons/react/solid";
import {
  Col,
  Row,
  Form,
  Button,
  InputGroup,
  Card,
  Modal,
} from "react-bootstrap";
import {
  useInsertVendorTransactionMutation,
  useGetVendorOptionsMutation,
  useGetVendorBalanceMutation,
} from "Services/services";
import { VendorWalletTable } from "components/Tables";
import TRANSACTIONS_DATA from "data/wallet";
import Select from "react-select";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import hasPermission from "pages/Permissions";

export default () => {
  const [transactions, setTransactions] = useState(
    TRANSACTIONS_DATA.map((t) => ({ ...t, show: true }))
  );
  const [searchValue, setSearchValue] = useState("");
  const [statusValue, setStatusValue] = useState("all");
  const [coordinatedCrm, setCoordinatedCrm] = useState(null);
  const [userDropDown] = useGetVendorOptionsMutation();
  const [balance] = useGetVendorBalanceMutation();
  const [transaction] = useInsertVendorTransactionMutation();
  const [amount, setAmount] = useState(0);
  const [users, setUsers] = useState();
  const [user, setUser] = useState();
  const [userId, setUserId] = useState();
  const [refreshTable, setRefreshTable] = useState(false);
  const transactionTypeOptions = [
    { value: "credit", label: "Credit" },
    { value: "debit", label: "Debit" },
  ];
  const [transactionalType, setTransactionalType] = useState(
  );
  const [showEdit, setShowEdit] = useState(false);
  const [remarks, setRemarks] = useState("");
  useEffect(() => {
    fetchUserDropdown();
  }, [amount]);

  const [validated, setValidated] = useState(false);

  const fetchUserDropdown = async () => {
    userDropDown()
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          const userOptions = response.data.data.queryData.map((user) => ({
            value: user.id, // Assuming `id` is the identifier you want to use
            label: `${user.vendor_name.toUpperCase()}`, // Assuming `username` is the label you want to display
          }));
          setUsers(userOptions);
        } else {
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        console.error("Error fetching user data", error);
      });
  };

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    const newTransactions = transactions.map((t) => {
      const subscription = t.subscription.toLowerCase();
      const shouldShow =
        subscription.includes(newSearchValue) ||
        `${t.price}`.includes(newSearchValue) ||
        t.status.includes(newSearchValue) ||
        `${t.invoiceNumber}`.includes(newSearchValue);

      return { ...t, show: shouldShow };
    });

    setSearchValue(newSearchValue);
    setTransactions(newTransactions);
  };

  const changeStatusValue = (e) => {
    const newStatusValue = e.target.value;
    const newTransactions = transactions.map((u) => ({
      ...u,
      show: u.status === newStatusValue || newStatusValue === "all",
    }));

    setStatusValue(newStatusValue);
    setTransactions(newTransactions);
  };
  const RequiredLabel = ({ label }) => (
    <Form.Label>
      {label}
      <span className="text-danger"> * </span>
    </Form.Label>
  );

  const [addAmount, setAddAmount] = useState("");

  const selectUserType = (selectedOption) => {
    balance({ user_id: selectedOption.value })
      .then((success) => {
        if (success?.data?.statusCode === 200) {
          setAmount(success.data.data.result?.totalBalance || 0);
        } else if (success?.data?.statusCode > 300) {
          setAmount(0);
          console.error("Verification failed");
        }
      })
      .catch((error) => {
        console.error("Verification failed", error);
      });

    setUserId(selectedOption.value);
  };

  const formatAmountWithIndianCommas = (amount) => {
    const x = amount.split(".");
    let lastThree = x[0].slice(-3);
    const otherNumbers = x[0].slice(0, -3);
    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }
    const result =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return x.length > 1 ? result + "." + x[1] : result;
  };

  const handleAmountChange = (e) => {
    const inputValue = e.target.value.replace(/,/g, "").replace(/₹/g, ""); // Remove existing commas and ₹ symbol
    if (!isNaN(inputValue) && inputValue.length <= 10) {
      const formattedValue = `₹${formatAmountWithIndianCommas(inputValue)}`;
      setAddAmount(formattedValue);
    }
  };

  const postData = {
    vendor_name: user?.label,
    vendor_id: user?.value,
    transaction_type: transactionalType?.value,
    amount: parseFloat(addAmount.replace(/[^0-9.-]+/g, "")) || 0,
    remarks: remarks,
  };

  const SwalWithBootstrapButtons = withReactContent(
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-secondary me-3",
        cancelButton: "btn btn-gray",
      },
      buttonsStyling: false,
    })
  );
  const submit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!user || !transactionalType || !addAmount){
      setValidated(true);
      return;
    } else {
      setShowEdit(true)
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    transaction(postData)
      .then((success) => {
        if (
          success?.data?.statusCode === 200 ||
          success?.data?.statusCode === 201
        ) {
          // setisVerifiedPhone(true);
          setShowEdit(false);
          setRemarks("");

          setUser("");
          setAddAmount("");
          setAmount(0);
          setValidated(false);
          setRefreshTable(!refreshTable);
          const confirmMessage = `The amount has been ${transactionalType?.value} successfully.`;
          SwalWithBootstrapButtons.fire("Approved", confirmMessage, "success");
          fetchUserDropdown();
        } else if (success?.data?.statusCode > 300) {
          setShowEdit(false);
          setRemarks("");
          // setisVerifiedPhone(false);
          setRefreshTable(!refreshTable);
          alert("Verification failed");
        }
      })
      .catch((error) => {
        setShowEdit(false);
        setRemarks("");
        setRefreshTable(!refreshTable);
        // setisVerifiedPhone(false);
        alert("Verification failed", error);
      });
  };

  const handleClose = () => {
    setShowEdit(false);
    setRemarks("");
  };

  const canEdit = hasPermission("Vendor Wallet", "edit");

  return (
    <>
      {canEdit && (
        <Card border="1" className="mb-3">
            <Card.Header className="mb-4 d-flex justify-content-between p-0 pb-2">
              <h5 className="mb-0">Wallet Management</h5>
            </Card.Header>
            <Form
            noValidate
            validated={validated}
            onSubmit={submit}
            autoComplete="off"
          >
            <Row>
              <Col md={6} lg={4} className="mb-3 text-left">
                <Form.Group id="cardNameLabel">
                  <RequiredLabel label="Vendor" />
                  <Select
                    options={users}
                    placeholder="Select Vendor"
                    className="mb-0"
                    isSearchable={true}
                    value={user}
                    onChange={(selectedOption) => {
                      setUser(selectedOption);
                      selectUserType(selectedOption);
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: validated && !user ? '#dc3545' :  validated && user ? '#65BB82': provided.borderColor,
                        borderRadius: '0.75rem',
                      }),
                    }}
                  />
                  {validated && !user &&
                     <div className="invalid-feedback d-block">
                     User selection is required.
                   </div>
                  }
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-4 align-item-right">
                <Form.Group id="cardNumberLabel">
                  <Form.Label>Current Wallet Amount</Form.Label>
                  <InputGroup>
                    <InputGroup.Text className="text-gray-600">
                      <CurrencyRupeeIcon className="icon icon-xs" />
                    </InputGroup.Text>
                    <Form.Control
                      disabled
                      type="text"
                      placeholder="0"
                      value={`${amount || 0}/-`}
                    title="This field is automatically populated on the basis of selected User"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3 text-left">
                <Form.Group id="transactionalTypeLabel">
                  <RequiredLabel label="Transactional Type" />
                  <Select
                    options={transactionTypeOptions}
                    placeholder="Select Type"
                    className="mb-0"
                    isSearchable={true}
                    value={transactionalType}
                    onChange={setTransactionalType}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: validated && !transactionalType ? '#dc3545' :  validated && transactionalType ? '#65BB82': provided.borderColor,
                        borderRadius: '0.75rem',
                      }),
                    }}
                  />
                   {validated && !transactionalType &&
                     <div className="invalid-feedback d-block">
                     Transactional Type selection is required.
                   </div>
                  }
                </Form.Group>
              </Col>

              <Col xs={12} md={6} lg={4} className="mb-4 mb-lg-0">
                <Form.Group id="cardCVCLabel">
                  <RequiredLabel label="Amount" />
                  <InputGroup>
                    <InputGroup.Text className="text-gray-600">
                      <CreditCardIcon className="icon icon-xs" />
                    </InputGroup.Text>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Ex: ₹1,000"
                      value={addAmount}
                      onChange={handleAmountChange}
                      maxLength={14} // Adjusted for ₹ symbol and commas
                    title="Amount must be a valid number"
                    />
                  </InputGroup>
                  {validated && !addAmount &&
                   <div className="invalid-feedback d-block">
                   Enter a valid Amount.
                 </div>
                }
                </Form.Group>
              </Col>

              <Col xs={12} className="mt-2 d-flex">
                <Button
                  variant="secondary"
                  className="animate-up-2 mt-2 ms-auto"
                  type="submit"
                >
                  Submit
                </Button>
              </Col>
            </Row>
            </Form>
        </Card>
      )}

      <VendorWalletTable key={refreshTable} />

      <Modal
        backdrop="static"
        keyboard={false}
        as={Modal.Dialog}
        centered
        show={showEdit}
        onHide={handleClose}
      >
        <Modal.Header>
          <Modal.Title className="h6">Transaction Confirmation</Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label htmlFor="remarks" className="form-label">
              Remarks
            </label>
            <textarea
              id="remarks"
              className="form-control"
              rows={3} // You can adjust the number of rows as needed
              value={remarks || ""} // Bind it to state
              onChange={(e) => setRemarks(e.target.value)} // Update the state on change
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="link"
            className="text-gray "
            onClick={handleClose}
          >
            Close
          </Button>
          <Button variant="secondary" onClick={(e) => handleSubmit(e)} className="ms-auto">
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
